import { type ReactNode } from "react";
import { recordLabel } from "@/ui";

export function FilterRow({ children, actions }: { children: ReactNode; actions?: ReactNode }) {
  return <div className="filter-row">{children}{actions && <div className="filter-row__actions">{actions}</div>}</div>;
}

export function ActiveFilters({ values, labels = {}, display = {}, clear }: { values: Record<string, string | null | undefined>; labels?: Record<string, string>; display?: Record<string, string>; clear: (key: string) => void }) {
  const active = Object.entries(values).filter(([, value]) => value);
  if (!active.length) return null;
  return <div className="chips active-filters" role="group" aria-label="Applied filters">{active.map(([key, value]) => <button key={key} className="chip" onClick={() => clear(key)} aria-label={`Clear ${labels[key] ?? recordLabel(key)}: ${display[value!] ?? value} filter`}>{labels[key] ?? recordLabel(key)}: {display[value!] ?? value}<span aria-hidden="true"> ×</span></button>)}</div>;
}
